export const PLATFORM_DASHBOARD_PATH = "/platform-dashboard";

export const PLATFORM_DASHBOARD_SECTIONS = [
  "tenant-management",
  "tenant-insights",
  "agent-runners",
] as const;

export type PlatformDashboardSection =
  (typeof PLATFORM_DASHBOARD_SECTIONS)[number];

export function platformDashboardSectionPath(
  section: PlatformDashboardSection,
): string {
  return `${PLATFORM_DASHBOARD_PATH}/${section}`;
}

export function isPlatformDashboardSection(
  value: string | undefined,
): value is PlatformDashboardSection {
  return (
    value !== undefined &&
    (PLATFORM_DASHBOARD_SECTIONS as readonly string[]).includes(value)
  );
}
